import CollapsiblePanel from './CollapsiblePanel.wrapper';

export default CollapsiblePanel;
